// "Connect bank / card" button. Loads a Plaid Link token from the server,
// hands it to the Plaid Link script (loaded in index.html), then exchanges the
// returned public_token for a long-lived access token on the server.
//
// Sandbox creds for testing: username "user_good" / password "pass_good".

import { useState } from 'react';
import { api } from '../lib/api.js';

export default function PlaidLink({ onSuccess, label = '+ Connect bank / card' }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  async function open() {
    setErr('');
    setBusy(true);
    try {
      if (!window.Plaid) throw new Error('Plaid Link script not loaded');
      const { link_token } = await api.post('/api/plaid/link-token');
      const handler = window.Plaid.create({
        token: link_token,
        onSuccess: async (public_token, metadata) => {
          try {
            await api.post('/api/plaid/exchange', {
              public_token,
              institution_name: metadata?.institution?.name,
            });
            setBusy(false);
            onSuccess?.();
          } catch (e) {
            setErr(e.message);
            setBusy(false);
          }
        },
        onExit: (e) => {
          if (e) setErr(e.display_message || e.error_message || 'Plaid exit');
          setBusy(false);
        },
      });
      handler.open();
    } catch (e) {
      setErr(e.message);
      setBusy(false);
    }
  }

  return (
    <span className="inline-flex items-center gap-2">
      <button className="btn-primary" onClick={open} disabled={busy}>
        {busy ? 'Opening…' : label}
      </button>
      {err && <span className="text-rust-700 text-xs">{err}</span>}
    </span>
  );
}
